const selectIncidentsCount = (state) =>
  state.polling.incidentsCount?.openIncidents + state.polling.incidentsCount?.challengedIncidents
const selectIncidentsCountLoaded = (state) => state.polling.incidentsCountLoaded
const selectError = (state) => state.polling.error

export { selectIncidentsCount, selectIncidentsCountLoaded, selectError }
